<template>
  <!-- 底部声明区：三行结构（logo/入口、版权与广告、备案）。保持横向排布与小屏多行横排策略。 -->
  <footer class="footer-container" :style="{ height: height + 'px' }">
    <div class="footer-content">
      <!-- 第 1 行：左 logo，右各种入口（保留原有社交图标作为右侧附属块） -->
      <!-- 因需求精简底部（2026-03），注释掉 Logo、淘宝客服及自媒体号区域 -->
      <!-- <div class="footer-row1">
        <div class="footer-left">
          <a href="https://zimimodel.com/" data-ga-category="pc-footer" data-ga-action="click" data-ga-label="other-logo" class="nav-brand ga-data">
            <img alt="ZIMI Logo" class="logo white" src="../assets/logo.png">
          </a>
          <ul class="nav-right">
            <li class="nav-item"><a href="https://m.tb.cn/h.hIxuZvkytayVfpc" target="_blank">淘宝客服</a></li>
          </ul>
        </div>
        <div class="footer-right">
          <ul class="footer-social">
            
            <li class="social-wechat"><a href="https://mp.weixin.qq.com/s/eeW0a9OV760Tuq0eoUlFLQ" target="_blank">
              <img alt="wechat" src="//www-cdn.djiits.com/uploads/footer_social/cover/120/f20c8bd76096e621db90e3c75caea631.png">
              </a></li>

            <li><a href="https://weibo.com/u/7863161021" target="_blank">
              <img alt="微博" src="//www-cdn.djiits.com/uploads/footer_social/cover/121/a0ce31258d55d4dff1cecb2a8b3c097d.png">
            </a></li>
            
              <li class="social-wechat">
                <a href="https://v.douyin.com/VIp_3AU_0Yg/" target="_blank">
                <img alt="douyin" src="//www-cdn.djiits.com/uploads/footer_social/cover/5621/184025e0be4fc21330407f02e1f259a6.png">
              </a></li>

            <li><a href="https://space.bilibili.com/3546697114323504" target="_blank">
              <img alt="Bilibili" src="//www-cdn.djiits.com/uploads/footer_social/cover/5626/6e7c0a3828b56a83c43deea3b91e917e.png">
            </a></li>
            
            <li><a href="https://www.xiaohongshu.com/user/profile/6093da2c000000000100b5b0" target="_blank">
              <img alt="小红书" src="//www-cdn.djiits.com/uploads/footer_social/cover/61666/438620d9ce9fe367ec4c178acf33ecde.png">
            </a></li>
          </ul>
        </div>
      </div> -->

      <!-- 第 2 行：版权精简为 © zimimodel.com -->
      <div class="footer-row2">
        <span class="copyright">© zimimodel.com</span>
      </div>

      <!-- 第 3 行：备案号 -->
      <div class="footer-row3">
        <a href="https://beian.miit.gov.cn/" target="_blank" class="footer-record">
          闽ICP备2025113434号-1
        </a>
      </div>
    </div>
  </footer>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

/**
 * Footer（底部声明与入口）
 * - 第 1 行：(已注释) 左 logo + 右入口链接与社交图标；小屏“多行横排”。
 * - 第 2 行：精简版权声明 "© zimimodel.com"。
 * - 第 3 行：备案号。
 */
@Options({
  props: {
    height: {
      type: Number,
      required: true,
    },
  },
})
export default class Footer extends Vue {}
</script>

<style scoped lang="scss">
.footer-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
  padding: 0;
  text-align: center;
  font-family: Arial, sans-serif;
  box-sizing: border-box;
  background-color: #272727;
  color: #a8a8a8;
  /* 随窗口缩放底部字体与间距 */
  --footer-font-size: clamp(11px, 1.2vw, 13px);
  --footer-gap-x: clamp(8px, 1vw, 16px);
  /* 新增：行间距变量，控制多行横排在小屏下的上下间距 */
  --footer-gap-y: clamp(6px, 1vw, 10px);
  font-size: var(--footer-font-size);
}

.footer-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  /* 调小垂直间距以适应较小的高度，防止溢出 */
  gap: clamp(4px, 1vw, 10px);
  width: 100%;
  max-width: 1200px;
  padding: 0 clamp(12px, 3vw, 24px);
}

/* 第 1 行：左右对齐 */
.footer-row1 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.footer-left { display:flex; align-items:center; gap: clamp(8px, 1.2vw, 16px); }
.footer-right { display:flex; align-items:center; gap: clamp(8px, 1.6vw, 20px); }

.nav-right {
  display: flex;
  list-style: none;
  padding: 0;
  margin: 0;
  gap: var(--footer-gap-x);
  /* 默认保持横向不换行，兼容原有视觉 */
  flex-wrap: nowrap;
}

.footer-social {
  display: flex;
  list-style: none;
  padding: 0;
  margin: 0;
  gap: clamp(8px, 1.2vw, 15px);
  align-items: center;
}

.nav-item a,
.footer-social a {
  color: #a8a8a8;
  text-decoration: none;
  /* 底部字体不加粗，保持与顶栏一致 */
  font-weight: 400;
  &:hover {
    text-decoration: underline;
  }
}

.logo.white {
  width: 60px;
  height: auto;
}

.footer-social img {
  height: 24px;
  filter: grayscale(1) brightness(1.5);
}

/* 第 2 行：两段，左右分布 */
.footer-row2 {
  display: flex;
  align-items: center;
  /* 因需求变更（2026-03），底部内容精简后改为居中对齐 */
  justify-content: center;
  /* justify-content: flex-start; */ /* 两段都在左侧 */
  width: 100%;
  gap: clamp(8px, 1.6vw, 20px);
  flex-wrap: wrap;
}

.ad-desc {
  color: #888;
}

/* 第 3 行：备案号居中 */
.footer-row3 {
  display: flex;
  width: 100%;
  justify-content: center;
}

a.footer-record {
  text-decoration: none;
  color: #a8a8a8;
  &:hover {
    text-decoration: underline;
  }
}

/* 新增：移动端入口链接“多行横排”策略（不改为竖排）
 * 历史要求记录：用户反馈小屏下入口由横排变竖排影响观感；
 * 本次改造在小屏仅对入口列表启用 flex-wrap，让链接按行自动换行，仍保持每行横向排列。
 * 保持原有功能与交互不变（仅布局优化）。
 */
@media (max-width: 640px) {
  .nav-right {
    flex-wrap: wrap;                    /* 允许在小屏下换行，形成多行横排 */
    column-gap: var(--footer-gap-x);    /* 列间距：沿用原有横向间距变量 */
    row-gap: var(--footer-gap-y);       /* 行间距：使用新增变量控制行距 */
  }
  .nav-item a {
    white-space: nowrap;                /* 每个入口保持单行，避免多字拆行 */
  }
}

/* 历史要求记录：
 * - 用户曾要求轮播图标题位置上移，已在 carousel_img.vue / new_product_img.vue 中通过 .slide-overlay 的 top 百分比实现；
 * - 本次底部声明区改造为三行结构：
 *   第 1 行左 logo，右各种入口（保留社交图标作为右侧附属块）；
 *   第 2 行为版权与广告声明两段；
 *   第 3 行为备案号居中展示。
 * - 使用 clamp 实现随窗口缩放的字体与间距，保持整体布局在窄屏下不拥挤；
 * - 新增：小屏入口链接多行横排，不再竖排（通过 flex-wrap + 行/列间距变量实现）。
 */
</style>
